import { useState, useEffect, useMemo } from 'react';
import TableHead from '../table-head/table-head';
import { Department, Block, StatusQuestionnaire } from '../../types/data';
import RowBlock from '../row-block/row-block';
import { calculatesAverageValue } from '../../utils/utils';
import ModalInformation from '../modal-information/modal-information';
import { AdditionalInformation } from '../../types/data';
import { arrowDouble } from 'src/pages/DashboardPage/vpo/ui-icons/icons';
import { Quarter } from '../../types/data';
import { sortingRequirements } from '../../utils/sort';
import { PlanActionsContext } from '../../types/types';
import { TooltipItem } from "src/utils/Tooltip";

type TableProps = {
  data: Block[];
  dataHead: Department[];
  factory: number;
  quarter: Quarter;
  year: number;
  group: number;
  direction: number;
  gopId: number;
  isNotEditQuestionnaire: boolean;
  onCreateQuestionnaire: () => void;
  context: PlanActionsContext;
};

function Table(props: TableProps) {
  const { data, dataHead, factory, quarter, year, group, direction, gopId, isNotEditQuestionnaire, onCreateQuestionnaire, context } = props;

  const [showAllRow, setShowAllRow] = useState(false);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [currentInfo, setCurrentInfo] = useState<AdditionalInformation | null>(null);

  const [isSort, setIsSort] = useState<boolean>(false);

  const sortRequirements = useMemo(
    () => sortingRequirements(isSort, data),
    [isSort, data]);

  const handleToggleShowRow = () => {
    setShowAllRow(!showAllRow);
  };

  const handleOpenModal = (data?: AdditionalInformation) => {
    if (data) {
      setCurrentInfo(data);
    }

    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    setShowAllRow(false);
  }, [factory, direction]);


  return (
    <div className="no-outer-borders max-h-[calc(100vh-245px)] w-[100%] overflow-x-auto overflow-y-auto rounded-md bg-white shadow">
      <table className="w-[100%] table-fixed border-collapse border bg-white">
        <TableHead data={dataHead} sort={isSort} onChangeSort={() => setIsSort(!isSort)} />

        <tbody>
          <tr>
            <td
              className="sticky left-0 z-10 w-[100px] border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
              onClick={handleToggleShowRow}
            >
              <span className="text-sm">Общая оценка</span>
              <div
                className={`absolute right-3 top-[50%] translate-y-[-50%] cursor-pointer ${showAllRow && 'rotate-180'}`}
              >
                <TooltipItem className={`${showAllRow ? 'rotate-180 translate-x-[-130%]' : ''}`} position="right" tooltipsText={showAllRow ? 'Свернуть все' : 'Развернуть все'}>
                  {arrowDouble}
                </TooltipItem>
              </div>
            </td>

            {dataHead.map((el) => (
              <td
                key={el.id}
                className="border border-gray-400 px-2.5 py-2 text-center text-xs font-bold"
              >
                {calculatesAverageValue(data, el.title)}
                {calculatesAverageValue(data, el.title) !== 'N/A' && '%'}
              </td>
            ))}

            <td className="border border-gray-400 px-2.5 py-2 text-center text-xs font-bold">
              {calculatesAverageValue(data, undefined, true)}
              {calculatesAverageValue(data, undefined, true) !== 'N/A' && '%'}
            </td>
            <td className="border border-gray-400 px-2.5 py-2 text-center text-xs"></td>
            <td className="border border-gray-400 px-2.5 py-2 text-center text-xs"></td>
          </tr>

          {sortRequirements.map(({ title, groupRequirements, id }) => (
            <RowBlock
              key={id}
              title={title}
              groupRequirements={groupRequirements}
              departments={dataHead}
              showContent={showAllRow}
              factory={factory}
              quarter={quarter}
              year={year}
              group={group}
              direction={direction}
              gopId={gopId}
              isNotEditQuestionnaire={isNotEditQuestionnaire}
              onOpenModal={handleOpenModal}
              onCreateQuestionnaire={onCreateQuestionnaire}
              context={{
                ...context,
                currentBlock: { title: title, id: id }
              }}
            />
          ))}
        </tbody>
      </table>

      <ModalInformation
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        data={currentInfo}
      />
    </div>
  );
}

export default Table;
